module.exports = __webpack_public_path__ + "static/wallace-dothan-1977bb251adf416ccde9b73e3f8c7a9a.jpg";